export class GameReelWildParticlesConfigFactory {
    static createNew(padding, width, height) {
        return {
            autoUpdate: true,
            frequency: 0.0035,
            maxParticles: 250,
            pos: {
                x: 0,
                y: 0,
            },
            lifetime: {
                min: 0.65,
                max: 0.85
            },
            addAtBack: true,
            behaviors: [
                {
                    type: "spawnShape",
                    config: {
                        type: "polygonalChain",
                        data: this.createSpawnZone(padding, width, height),
                    }
                },
                {
                    type: "scale",
                    config: {
                        scale: {
                            list: [{ value: 0, time: 0 }, { value: 0.25, time: 0.05 }, { value: 0, time: 1 }],
                            isStepped: false
                        },
                        minMult: 0.1
                    }
                },
                {
                    type: "textureRandom",
                    config: {
                        textures: [
                            "Game-Particle"
                        ]
                    }
                },
                {
                    type: "rotationStatic",
                    config: {
                        min: 0,
                        max: 360,
                    }
                },
                {
                    type: "moveAcceleration",
                    config: {
                        accel: {
                            x: 0,
                            y: 0,
                        },
                        minStart: 0,
                        maxStart: 30,
                        rotate: true,
                    }
                },
            ]
        };
    }
    static createSpawnZone(padding, width, height) {
        return [
            [
                { x: padding.x, y: padding.y },
                { x: padding.x + width, y: padding.y },
                { x: padding.x + width, y: padding.y + height },
                { x: padding.x, y: padding.y + height },
                { x: padding.x, y: padding.y }
            ],
            //Include these lines below for the reel to also be separated
            // [
            // 	{ x: padding.x, y: padding.y + midLineHeight },
            // 	{ x: padding.x + width, y: padding.y + midLineHeight }
            // ]
        ];
    }
}
//# sourceMappingURL=GameReelWildParticleEmitterConfig.js.map